import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyValueDTO } from '@ms/core';
import { Observable } from 'rxjs';
import { ExamSearch } from '../exams/exam-list/exams-search.model';
import { Exam, IExam, IExamList } from '../exams/model/exam.model';
import { IField } from '../shared/fields-table/field.model';
import { logRequest } from '../shared/http-utils';
import { FieldService } from './field.service';
import { SchoolService } from './school.service';

@Injectable({
    providedIn: 'root',
})
export class ExamService implements FieldService {
    baseUrl = '/school-service/api/exams';

    constructor(
        private http: HttpClient,
        private schoolService: SchoolService
    ) {
        console.log('Exam service created');
    }

    getExams(): Observable<IExam[]> {
        const schoolId = this.schoolService.getActiveSchool().id;
        return this.http.get<IExam[]>(`${this.baseUrl}/${schoolId}/school`);
    }

    getExamById(id: string): Observable<HttpResponse<IExam>> {
        return this.http.get<IExam>(`${this.baseUrl}/${id}`, {
            observe: 'response',
        });
    }

    getExamsByGradeLevelId(gradeLevelId: string): Observable<IExam[]> {
        const schoolId = this.schoolService.getActiveSchool().id;
        return this.http.get<IExam[]>(`${this.baseUrl}/${schoolId}/${gradeLevelId}/gradeLevel`);
    }

    createExam(exam: Exam): Observable<HttpResponse<IExam>> {
        exam.school = this.schoolService.getActiveSchool().id;
        return this.http.post<IExam>(this.baseUrl, exam, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    updateExam(exam: IExam): Observable<HttpResponse<IExam>> {
        exam.schoolId = this.schoolService.getActiveSchool().id;
        console.log(`Service Exam ${exam}`);
        return this.http.put<IExam>(this.baseUrl, exam, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    updateExamActiveness(exam: IExamList): Observable<HttpResponse<any>> {
        return this.http.patch<any>(`${this.baseUrl}/active`, exam, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    deleteExam(id: number): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${id}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    map(response: IExam): IExam {
        const result: IExam = Object.assign({}, response);
        result.gradeLevel = Object.assign({}, result.gradeLevel);
        //  result.attachment-types = [].concat(result.attachment-types ? result.attachment-types : []);

        return result;
    }

    searchExams(examSearchDTO: ExamSearch): Observable<HttpResponse<IExamList[]>> {
        examSearchDTO.schoolId = this.schoolService.getActiveSchool().id;
        return this.http.post<IExamList[]>(`${this.baseUrl}/search`, examSearchDTO, { observe: 'response' });
    }

    getExamsByGradeLevelIdKeyValue(gradeLevelId: string): Observable<KeyValueDTO[]> {
        const schoolId = this.schoolService.getActiveSchool().id;
        return this.http.get<KeyValueDTO[]>(`/school-service/api-public/exams/${gradeLevelId}/gradeLevel/${schoolId}`);
    }

    createField(entityId: string, field: IField): Observable<HttpResponse<IField>> {
        return this.http.patch<IField>(`${this.baseUrl}/${entityId}/create-field`, field, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    updateField(entityId: string, field: IField): Observable<HttpResponse<IField>> {
        return this.http.patch<IField>(`${this.baseUrl}/${entityId}/update-field`, field, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    deleteField(entityId: string, fieldId: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${entityId}/fieldId/${fieldId}`, {
            observe: 'response',
            headers: logRequest(),
        });
    }
}
